import styled, { css } from 'styled-components';
import { Button } from '@vgrubs/components';

/**
 * The app's button, with room for an icon beside the label.
 *
 * `Button` wraps its children in a span of its own, which is what has to become
 * the flex row - and it only colours its icons for the filled hover state, so
 * the resting state needs one of its own. `ChatIcon` is drawn white for the red
 * sidebar it was made for, which is right on the filled button and invisible on
 * the outlined one, so the fill follows the label.
 */
export const ChatButtonStyled = styled(Button)`
  padding: 0 20px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  /*
   * The filled state, spelled out again rather than handed to the button.
   *
   * styled-components 5 consumes transient props: a $-prefixed prop reaches
   * THIS template and is then dropped from what the wrapped component is
   * rendered with, so the $selected at the call site would otherwise style
   * nothing. Two declarations - the button's own fill slides in from the left
   * on hover, and this is that slide already finished.
   */
  ${({ theme, $selected }) =>
    $selected &&
    css`
      color: ${theme.white};

      ::before {
        transform: translateX(0);
      }
    `}

  svg {
    width: 18px;
    height: 18px;

    path {
      fill: ${({ theme, $selected }) =>
        $selected ? theme.white : theme.primary};
      transition: ${({ theme }) => theme.transitions.ease200ms};
    }
  }

  :hover svg path {
    fill: ${({ theme }) => theme.white};
  }
`;
